import React, {FC, useEffect, useMemo, useState} from 'react';
import {
    Scrollbar,
    Table as PSTable,
    TableProperties
} from '@priority-software/priority-style-react';
import styles from './Table.module.scss';
import {isRTL} from '../../../../Localization';
import classNames from 'classnames';

export const Table: FC<TableProperties> = props => {
    const isRtl = isRTL();

    const [height, setHeight] = useState(0);

    useEffect(() => {
        const updateWindowDimensions = () => {
            const newHeight = window.innerHeight;
            setHeight(newHeight);
        };

        window.addEventListener('resize', updateWindowDimensions);

        updateWindowDimensions();

        return () => window.removeEventListener('resize', updateWindowDimensions);
    }, []);

    const wrapperClassname = useMemo(
        () =>
            classNames(styles.wrapper, {
                [styles.wrapperRtl]: isRtl
            }),
        [isRtl]
    );

    return height > 740 ? (
        <Scrollbar rtl={isRtl} componentClasses={wrapperClassname}>
            <PSTable {...props} componentClasses={styles.table} />
        </Scrollbar>
    ) : (
        <div className={wrapperClassname}>
            <PSTable {...props} componentClasses={styles.table} />
        </div>
    );
};
